import React from 'react';
import { Polyline } from 'react-leaflet';
import { formatedTrackPath } from '../../utils/helperFunctions';

const Road = ({ roadData, roadIndex, onRoadClick }) => {
    const positions = formatedTrackPath(roadData);
    if (!Array.isArray(positions) || positions.length < 2) return null;

    // Handle road click event
    const handleRoadClick = (e) => {
        if (typeof onRoadClick === 'function') onRoadClick(e); // Pass the lat/lng to the parent click handler
    };

    // Define base color and hover color
    const baseColor = '#009DDC'; // Base road color


    return (
        <Polyline
            key={roadIndex}
            weight={'12'}
            pathOptions={{
                color: baseColor, // Change color on hover
                lineCap: 'round',
                lineJoin: 'miter'
            }}
            positions={positions} // Convert the road data to proper format
            eventHandlers={{
                click: handleRoadClick, // Handle the road click

            }}
        />
    );
};

export default Road;
